/* ===========================================================================
   Sticky
   =========================================================================== */

import { $aside } from '../settings/settings';

const windowHeight = screen.height;

/**
 * [sticky description]
 * @return {[type]} [description]
 */
export function sticky($elem, asideHeight) {

  const $sticky = document.querySelector('.js-sticky');
  if ($sticky !== undefined && $sticky !== null) {
    const stickyHeight = $sticky.clientHeight;

    if (stickyHeight < windowHeight) {
      $sticky.classList.add('sticky');
    }
  }
}
